import React from 'react';
import './ComingSoon.scss';

interface ComingSoonProps {
  title?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title = 'Coming Soon' }) => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <div className="coming-soon-icon">
          <i className="bx bx-time-five"></i>
        </div>
        <h2 className="coming-soon-title">{title}</h2>
        <p className="coming-soon-message">
          We're working hard to bring you this feature. Stay tuned!
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;

